var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { ErrorCodes, ExceptionHandlerClass } from '../System/Aop';
var DirtyModel = (function () {
    function DirtyModel(name, properties) {
        this.myName = name;
        this.myProperties = properties;
    }
    Object.defineProperty(DirtyModel.prototype, "name", {
        get: function () { return this.myName; },
        set: function (value) {
            this.myName = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DirtyModel.prototype, "mapperId", {
        get: function () { return this.myMapperId; },
        set: function (value) {
            this.myMapperId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DirtyModel.prototype, "properties", {
        get: function () { return this.myProperties; },
        set: function (value) {
            this.myProperties = value;
        },
        enumerable: false,
        configurable: true
    });
    DirtyModel.prototype.toReduce = function () {
        return this.minProperties();
    };
    DirtyModel.prototype.minProperties = function () {
        var props = {};
        this.properties.forEach(function (property) {
            props[property.name] = property.value;
        });
        return props;
    };
    DirtyModel = __decorate([
        ExceptionHandlerClass(ErrorCodes.ClientCore),
        __metadata("design:paramtypes", [String, Array])
    ], DirtyModel);
    return DirtyModel;
}());
export { DirtyModel };
